import { AvailableLocale } from '@omnea-digital/toolbox'

export const getBrowserLocale = (() => {
  if (typeof navigator === 'undefined') {
    console.error('getBrowserLocale called in a non-browser environment')
    return null
  }

  const { language } = navigator

  // US English (🇺🇸)
  if (language.startsWith('en-US')) {
    return 'en-US'
  }

  const languageCode = language.slice(0, 2)

  switch (languageCode) {
    case 'en':
      return 'en-GB' // Other English locales default to British (🇬🇧)
    case 'fr':
      return 'fr-FR' // All French locales default to French (🇫🇷)
    case 'es':
      return 'es-ES' // All Spanish locales default to Spanish (🇪🇸)
    case 'it':
      return 'it-IT' // All Italian locales default to Italian (🇮🇹)
    case 'de':
      return 'de-DE' // All German locales default to German (🇩🇪)
    default:
      return null // Browser locale unsupported
  }
}) satisfies () => AvailableLocale | null

export const isBrowserDateFormatAmerican = () => {
  const testDate = new Date(2000, 0, 31)

  // Localised with the system locale
  const localisedDate = testDate.toLocaleDateString()

  // If the date was localised to 01/31/2000, then the date format is American
  const firstPart = localisedDate.split('/')[0]
  return Number(firstPart) === 1
}
